(function () {
    'use strict';

    angular.module('thankview.signup', ['ngTouch', 'thankview.global', 'thankview.auth'])
        .controller('RegisterController', ['$scope', '$rootScope', '$window', '$document', function ($scope, $rootScope, $window, $document) {
            $scope.isLogin = false;
            $rootScope.bodyStyle = {
                height: '100%',
                display: 'table',
                background: 'linear-gradient(134deg, #3367F2, #4E7F1C)',
            };

            $scope.checkValid = function ($event) {
                if (!config.cookieEnabled) {
                    $rootScope.$broadcast('open-message', 'Your cookies are disabled. Please enable cookies to sign up.');
                    $event.preventDefault();
                }

                if (!$scope.form.$valid) {
                    $scope.form.$setSubmitted();
                    $event.preventDefault();
                }
            };

            $scope.goBack = function () {
                $window.history.back();
            };

            $scope.openFbLogin = function ($event) {
                $event.preventDefault();

                if (!$window.FB) {
                    return;
                }

                FB.login(function (response) {
                    if (response.status === 'connected') {
                        $rootScope.$broadcast('open-loading');

                        $scope.fbAccessToken = response.authResponse.accessToken;
                        $scope.$apply();

                        $document[0].querySelector('form[name=form]').submit();
                    }
                }, {
                    scope: 'email',
                });
            };
        }]);
}());
